export const generatedModelValidationProtocolLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-model-validation-protocol-ledger",
  "operatingRule": "Business-grade modeling requires explicit validation protocols, acceptance criteria, source/runtime gates, and blocker states before any model output can be sold as evidence.",
  "protocolCount": 9,
  "blockedProtocolCount": 9,
  "commercialUseAllowed": false,
  "stateCounts": {
    "beta-reviewable-non-commercial": 2,
    "blocked-validation-gaps": 7
  },
  "evidenceHashes": {
    "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
  },
  "topProtocolGaps": [
    {
      "id": "protocol-ephemeris-event-windows",
      "domain": "ephemeris-event-windows",
      "title": "Ephemeris geometry and contact/event-window validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 1,
      "nextAction": "Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1"
    },
    {
      "id": "protocol-small-body-feedstock",
      "domain": "small-body-feedstock",
      "title": "Small-body orbit, close-approach, and resource-candidate validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 5,
      "nextAction": "Runtime sidecar artifact not promoted: orekit-propagation-v1"
    },
    {
      "id": "protocol-trajectory-logistics",
      "domain": "trajectory-logistics",
      "title": "Trajectory, transfer, and logistics cross-tool validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 7,
      "nextAction": "Runtime sidecar artifact not promoted: orekit-propagation-v1"
    },
    {
      "id": "protocol-comms-autonomy",
      "domain": "comms-autonomy",
      "title": "Communications, blackout, and autonomy validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 3,
      "nextAction": "Source payload not promoted: nasa-dtn"
    },
    {
      "id": "protocol-space-environment",
      "domain": "space-environment",
      "title": "Radiation, plasma, and solar-weather validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 4,
      "nextAction": "Source payload not promoted: nasa-spdf"
    },
    {
      "id": "protocol-materials-process",
      "domain": "materials-process",
      "title": "Materials, chemistry, thermal, and process-fit validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 9,
      "nextAction": "Source payload not promoted: nist-chemistry-webbook"
    },
    {
      "id": "protocol-economics-frontier",
      "domain": "economics-optimization",
      "title": "Economics, uncertainty, and crossover-frontier validation",
      "validationState": "blocked-validation-gaps",
      "blockerCount": 7,
      "nextAction": "Source payload not promoted: spacex-rideshare"
    }
  ],
  "protocols": [
    {
      "id": "protocol-evidence-provenance",
      "domain": "evidence-and-provenance",
      "capabilityId": "evidence-provenance",
      "title": "Claim and artifact provenance validation",
      "modelClass": "governance",
      "requiredSourceIds": [
        "horizons-api",
        "sbdb-api",
        "cad-api",
        "pds",
        "nist-codata"
      ],
      "requiredContractIds": [],
      "acceptanceCriteria": [
        "Every source-backed claim links to source records, query metadata, units, uncertainty, and a stable hash.",
        "Every generated model artifact records source ids, limitations, claim state, and a reproducible artifact hash.",
        "Commercial use remains blocked when any required source, runtime, or review gate is missing."
      ],
      "testVectors": [
        "Claim evidence ledger has verified and blocked claim states.",
        "Model artifact bundle has blockedArtifactCount equal to artifactCount until runtime/source gates pass.",
        "Research packages include package hashes, allowed-use language, and blocker lists."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "beta-reviewable-non-commercial",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "evidence-provenance",
        "maturityScore": 78.94,
        "maturityBand": "beta-reviewable",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-7e744aa89d353106b30afd2a0ae930990b7678a675a3e8e3279612300eaf1706"
      },
      "coverage": {
        "registeredSources": {
          "required": 5,
          "present": 5,
          "missing": []
        },
        "promotedSources": {
          "required": 5,
          "present": 5,
          "missing": []
        },
        "promotedContracts": {
          "required": 0,
          "present": 0,
          "missing": []
        }
      },
      "blockers": [],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-793627be3059f343ee2f7aa291d7fd819c4387d24788774051f5d6182e65acdb"
    },
    {
      "id": "protocol-ephemeris-event-windows",
      "domain": "ephemeris-event-windows",
      "capabilityId": "ephemeris-event-windows",
      "title": "Ephemeris geometry and contact/event-window validation",
      "modelClass": "physics-runtime",
      "requiredSourceIds": [
        "horizons-api",
        "spice-gf",
        "iau-sofa"
      ],
      "requiredContractIds": [
        "spice-gf-event-window-v1"
      ],
      "acceptanceCriteria": [
        "Horizons snapshot records preserve query, target, observer, time scale, units, and response hash.",
        "SPICE Geometry Finder artifact preserves kernel manifest hash, constraints, TDB/ET time key, and window outputs.",
        "Distance, light-time, elongation, and event-window outputs remain within declared tolerances."
      ],
      "testVectors": [
        "Mercury nominal irradiance agrees with the cached Horizons snapshot tolerance.",
        "SPICE GF worker fails closed without kernel manifest custody.",
        "Contact/conjunction windows are not generated by hand-rolled threshold logic when SPICE is available."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "ephemeris-event-windows",
        "maturityScore": 65.49,
        "maturityBand": "research-backed",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-ec170468acb6a970fd48343370f7aa8e9b9132f2a2d4edba492d851b4a335e0a"
      },
      "coverage": {
        "registeredSources": {
          "required": 3,
          "present": 3,
          "missing": []
        },
        "promotedSources": {
          "required": 3,
          "present": 3,
          "missing": []
        },
        "promotedContracts": {
          "required": 1,
          "present": 1,
          "missing": []
        }
      },
      "blockers": [
        "Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1"
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-4aef6e4c4fd115f5dd086dfa3c2a9895f3cc5853cdce2e9b7380c410f5a986d7"
    },
    {
      "id": "protocol-small-body-feedstock",
      "domain": "small-body-feedstock",
      "capabilityId": "small-body-feedstock",
      "title": "Small-body orbit, close-approach, and resource-candidate validation",
      "modelClass": "source-plus-runtime",
      "requiredSourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "requiredContractIds": [
        "orekit-propagation-v1",
        "tudat-transfer-v1"
      ],
      "acceptanceCriteria": [
        "Object-specific SBDB/CAD/MPC records preserve orbit solution, close-approach geometry, uncertainty, and retrieval hash.",
        "Resource class remains unknown unless taxonomy, spectra, meteorite analog, or mission product evidence is attached.",
        "Trajectory screening references at least one runtime propagation artifact before candidate promotion."
      ],
      "testVectors": [
        "Synthetic asteroid candidates stay blocked from verified resource promotion.",
        "Candidate ledger requires taxonomy/spectra/mission data before resource claims.",
        "Mercury or asteroid scenarios can lose under conservative assumptions."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "small-body-feedstock",
        "maturityScore": 50.09,
        "maturityBand": "contracted-backlog",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-1b30bc23134ff16878cdbaec11e9503937d16fafa7bb3669739e99caf25a219a"
      },
      "coverage": {
        "registeredSources": {
          "required": 6,
          "present": 6,
          "missing": []
        },
        "promotedSources": {
          "required": 6,
          "present": 6,
          "missing": []
        },
        "promotedContracts": {
          "required": 2,
          "present": 0,
          "missing": [
            "orekit-propagation-v1",
            "tudat-transfer-v1"
          ]
        }
      },
      "blockers": [
        "Runtime sidecar artifact not promoted: orekit-propagation-v1",
        "Runtime sidecar artifact not promoted: tudat-transfer-v1",
        "Capability blocker: Runtime sidecar validation blocked: orekit-propagation-v1",
        "Capability blocker: Runtime sidecar validation blocked: tudat-transfer-v1",
        "Capability blocker: Claim not promotable: claim-helium3"
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-e2a6133eb3835d8532f97fc3040426061582bca11eda0ee036e668f84c731224"
    },
    {
      "id": "protocol-trajectory-logistics",
      "domain": "trajectory-logistics",
      "capabilityId": "trajectory-logistics",
      "title": "Trajectory, transfer, and logistics cross-tool validation",
      "modelClass": "physics-runtime",
      "requiredSourceIds": [
        "orekit",
        "gmat",
        "tudat",
        "openmdao",
        "dymos"
      ],
      "requiredContractIds": [
        "orekit-propagation-v1",
        "gmat-transfer-v1",
        "tudat-transfer-v1",
        "openmdao-dymos-optimization-v1"
      ],
      "acceptanceCriteria": [
        "Orekit/GMAT/Tudat artifacts record force model, frame, time scale, integrator/optimizer settings, and residual bounds.",
        "At least two independent trajectory tools agree within declared residual tolerance before mission-design promotion.",
        "OpenMDAO/Dymos optimization records objective, constraints, design variables, seed, and sensitivity outputs."
      ],
      "testVectors": [
        "Sidecar intake rejects contract-only artifacts and accepts only complete runtime artifacts.",
        "OpenMDAO/Dymos runtime artifact promotes through intake while contract gaps remain visible.",
        "Orekit, GMAT, and Tudat scaffolds fail closed until external runtimes and inputs are present."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "trajectory-logistics",
        "maturityScore": 49.98,
        "maturityBand": "contracted-backlog",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-bd1b2ee7d2b24ded850c560ccade38948c32d67395cb8e242c6e932dbcf19845"
      },
      "coverage": {
        "registeredSources": {
          "required": 5,
          "present": 5,
          "missing": []
        },
        "promotedSources": {
          "required": 5,
          "present": 5,
          "missing": []
        },
        "promotedContracts": {
          "required": 4,
          "present": 1,
          "missing": [
            "orekit-propagation-v1",
            "gmat-transfer-v1",
            "tudat-transfer-v1"
          ]
        }
      },
      "blockers": [
        "Runtime sidecar artifact not promoted: orekit-propagation-v1",
        "Runtime sidecar artifact not promoted: gmat-transfer-v1",
        "Runtime sidecar artifact not promoted: tudat-transfer-v1",
        "Capability blocker: Runtime sidecar validation blocked: orekit-propagation-v1",
        "Capability blocker: Runtime sidecar validation blocked: gmat-transfer-v1",
        "Capability blocker: Runtime sidecar validation blocked: tudat-transfer-v1",
        "Capability blocker: Runtime sidecar validation blocked: openmdao-dymos-optimization-v1"
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-eb25f5788db6b754dccd4f4bed46d978b0ecb33912b50897f221139c3a39c741"
    },
    {
      "id": "protocol-comms-autonomy",
      "domain": "comms-autonomy",
      "capabilityId": "comms-autonomy",
      "title": "Communications, blackout, and autonomy validation",
      "modelClass": "engineering-heuristic-plus-event-runtime",
      "requiredSourceIds": [
        "nasa-dtn",
        "ccsds",
        "spice-gf",
        "horizons-api"
      ],
      "requiredContractIds": [
        "spice-gf-event-window-v1"
      ],
      "acceptanceCriteria": [
        "Free-space path loss, light-time, and latency calculations are unit-tested and source-linked.",
        "Solar-interference and blackout windows come from reviewed ephemeris/event-window artifacts.",
        "Autonomy load and blackout-safe manufacturing windows are labeled as planner heuristics until mission-specific link budgets exist."
      ],
      "testVectors": [
        "Free-space path loss increases with distance and frequency.",
        "Light-time and round-trip latency are reproducible.",
        "Blackout-safe manufacturing windows expose process duration, margin, and slack."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "comms-autonomy",
        "maturityScore": 62.08,
        "maturityBand": "research-backed",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-8f13afb390aa9535da156eb354c9272eaec138d89c282d8e4dea2f91de40f749"
      },
      "coverage": {
        "registeredSources": {
          "required": 4,
          "present": 4,
          "missing": []
        },
        "promotedSources": {
          "required": 4,
          "present": 2,
          "missing": [
            "nasa-dtn",
            "ccsds"
          ]
        },
        "promotedContracts": {
          "required": 1,
          "present": 1,
          "missing": []
        }
      },
      "blockers": [
        "Source payload not promoted: nasa-dtn",
        "Source payload not promoted: ccsds",
        "Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1"
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-aec24f46a6b01243742cd86a6cc49be5b6d626317a0031ecf114d1dd4d8aa5a2"
    },
    {
      "id": "protocol-space-environment",
      "domain": "space-environment",
      "capabilityId": "space-environment",
      "title": "Radiation, plasma, and solar-weather validation",
      "modelClass": "environment-source-artifact",
      "requiredSourceIds": [
        "nasa-spdf",
        "nasa-ccmc",
        "noaa-swpc"
      ],
      "requiredContractIds": [],
      "acceptanceCriteria": [
        "SPDF/CDAWeb records include dataset id, variables, cadence, time range, calibration notes, and retrieval hash.",
        "CCMC model runs preserve model name, version, input deck, run id, and output hash.",
        "SWPC products are dated, horizon-scoped, and never treated as deterministic long-range environment truth."
      ],
      "testVectors": [
        "Capability ledger blocks space-environment commercialization until runtime/source artifacts exist.",
        "Evidence gap ledger exposes missing SPDF/CCMC/SWPC artifact work.",
        "Environment assumptions remain scenario constraints, not verified engineering predictions."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "space-environment",
        "maturityScore": 65.22,
        "maturityBand": "research-backed",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-b7a78156a88135d6762ec1fda91b7e4f47db8642667cf278eb44686cb8d1eaa3"
      },
      "coverage": {
        "registeredSources": {
          "required": 3,
          "present": 3,
          "missing": []
        },
        "promotedSources": {
          "required": 3,
          "present": 0,
          "missing": [
            "nasa-spdf",
            "nasa-ccmc",
            "noaa-swpc"
          ]
        },
        "promotedContracts": {
          "required": 0,
          "present": 0,
          "missing": []
        }
      },
      "blockers": [
        "Source payload not promoted: nasa-spdf",
        "Source payload not promoted: nasa-ccmc",
        "Source payload not promoted: noaa-swpc",
        "Capability blocker: No SPDF/CCMC/SWPC runtime environment artifact has been generated."
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-70feac14a3aa87120978c9c6e0f4c4a6aca51bc43cb31ce7586f9e6362bb07f1"
    },
    {
      "id": "protocol-materials-process",
      "domain": "materials-process",
      "capabilityId": "materials-process",
      "title": "Materials, chemistry, thermal, and process-fit validation",
      "modelClass": "materials-and-process-runtime",
      "requiredSourceIds": [
        "nist-codata",
        "nist-chemistry-webbook",
        "materials-project",
        "cantera",
        "moose-framework",
        "openfoam",
        "pds"
      ],
      "requiredContractIds": [],
      "acceptanceCriteria": [
        "NIST and Materials Project records preserve species/material ids, fields, units, methods, uncertainty, and hash.",
        "Cantera/MOOSE/OpenFOAM artifacts preserve mechanism/input deck/case hash, solver version, tolerances, and residuals.",
        "Process-body fit scores remain labeled heuristics until physics/process artifacts are generated and reviewed."
      ],
      "testVectors": [
        "Thermal estimates distinguish subsolar from spherical average cases.",
        "Planner heuristics cannot be labeled established physics.",
        "Capability ledger blocks materials/process commercialization until Cantera/MOOSE/OpenFOAM artifacts exist."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "materials-process",
        "maturityScore": 62.91,
        "maturityBand": "research-backed",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-f1a64fb4d0463e51949fafc8a590e82b46f0e20557e89a57cebdb5e6ed8df386"
      },
      "coverage": {
        "registeredSources": {
          "required": 7,
          "present": 7,
          "missing": []
        },
        "promotedSources": {
          "required": 7,
          "present": 2,
          "missing": [
            "nist-chemistry-webbook",
            "materials-project",
            "cantera",
            "moose-framework",
            "openfoam"
          ]
        },
        "promotedContracts": {
          "required": 0,
          "present": 0,
          "missing": []
        }
      },
      "blockers": [
        "Source payload not promoted: nist-chemistry-webbook",
        "Source payload not promoted: materials-project",
        "Source payload not promoted: cantera",
        "Source payload not promoted: moose-framework",
        "Source payload not promoted: openfoam",
        "Capability blocker: Claim not promotable: claim-spf-separation",
        "Capability blocker: Materials/process gap: Superplastic Forming / Diffusion Bonding requires thermal cycle energy balance",
        "Capability blocker: Materials/process gap: Vacuum Anisotropic Sheet Manufacturing requires MOOSE thermo-mechanical forming residual record",
        "Capability blocker: Materials/process gap: Oxygen Extraction / ISRU requires Cantera chemistry/thermodynamics run"
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-95c50ec7fea3f2e2d7d68a00e3f8f7fd7c325f752f4ce78961e69432ee5118db"
    },
    {
      "id": "protocol-economics-frontier",
      "domain": "economics-optimization",
      "capabilityId": "economics-optimization",
      "title": "Economics, uncertainty, and crossover-frontier validation",
      "modelClass": "business-modeling",
      "requiredSourceIds": [
        "spacex-rideshare",
        "nasa-clps",
        "nasa-cost-estimating-handbook",
        "usaspending",
        "sec-edgar"
      ],
      "requiredContractIds": [
        "openmdao-dymos-optimization-v1"
      ],
      "acceptanceCriteria": [
        "Launch, delivery, capex, opex, award, and filing records are dated, normalized, and linked to model inputs.",
        "Monte Carlo seeds, assumptions, rank stability, and Pareto/frontier outputs are reproducible.",
        "No single forced winner is presented; rankings expose sensitivity and conditions where each scenario loses."
      ],
      "testVectors": [
        "Economics frontier preserves deterministic scenario coverage and blockers.",
        "Economics frontier avoids Mercury-first hardcoding.",
        "Assumption impact ledger exposes rank and utility sensitivity."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "blocked-validation-gaps",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "economics-optimization",
        "maturityScore": 54.03,
        "maturityBand": "contracted-backlog",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-bc5c0a71ef42ed8b2e8d50ce4d022e846c30a23941169b3059103422a81615ae"
      },
      "coverage": {
        "registeredSources": {
          "required": 5,
          "present": 5,
          "missing": []
        },
        "promotedSources": {
          "required": 5,
          "present": 0,
          "missing": [
            "spacex-rideshare",
            "nasa-clps",
            "nasa-cost-estimating-handbook",
            "usaspending",
            "sec-edgar"
          ]
        },
        "promotedContracts": {
          "required": 1,
          "present": 1,
          "missing": []
        }
      },
      "blockers": [
        "Source payload not promoted: spacex-rideshare",
        "Source payload not promoted: nasa-clps",
        "Source payload not promoted: nasa-cost-estimating-handbook",
        "Source payload not promoted: usaspending",
        "Source payload not promoted: sec-edgar",
        "Capability blocker: Runtime sidecar validation blocked: openmdao-dymos-optimization-v1",
        "Capability blocker: Dated launch/capex/opex/market source records are not attached."
      ],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-968c81718149bfce122f8d6fcbb398bb108720d40fbb38a547b8e07550a65ab3"
    },
    {
      "id": "protocol-research-package-release",
      "domain": "business-research-workflow",
      "capabilityId": "business-research-workflow",
      "title": "Research-package release and reviewer approval validation",
      "modelClass": "business-workflow",
      "requiredSourceIds": [
        "pds",
        "horizons-api",
        "sbdb-api",
        "cad-api"
      ],
      "requiredContractIds": [],
      "acceptanceCriteria": [
        "Every paid-beta package includes report, source, claim, scenario, run, assumption, capability, and release ledger hashes.",
        "Human approval is recorded separately from source/runtime validation.",
        "Release remains blocked until Access, monitor, alerting, UI, science, source, package, and review gates pass."
      ],
      "testVectors": [
        "Research packages expose allowed-use language and blockers.",
        "Release evidence ledger keeps blocked gates explicit.",
        "Deploy preflight validates live Access, monitor token protection, and public artifacts."
      ],
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "validationState": "beta-reviewable-non-commercial",
      "commercialUseAllowed": false,
      "capabilitySnapshot": {
        "capabilityId": "business-research-workflow",
        "maturityScore": 78.95,
        "maturityBand": "beta-reviewable",
        "commercializationAllowed": false,
        "capabilityHash": "sha256-7e183b1d62f96927df37a94e88858e7538c5b937b073e7d6820e9536029e39a0"
      },
      "coverage": {
        "registeredSources": {
          "required": 4,
          "present": 4,
          "missing": []
        },
        "promotedSources": {
          "required": 4,
          "present": 4,
          "missing": []
        },
        "promotedContracts": {
          "required": 0,
          "present": 0,
          "missing": []
        }
      },
      "blockers": [],
      "requiredReviewEvidence": [
        "source payload intake report hash",
        "runtime sidecar intake report hash when required",
        "model/run artifact hash",
        "unit and uncertainty mapping",
        "independent comparison or residual bounds when applicable",
        "reviewer decision and allowed-use statement"
      ],
      "evidenceBoundary": "This protocol defines validation gates and acceptance criteria. It is not itself proof that a model, source, or business claim is validated.",
      "protocolHash": "sha256-329dbe9a04571b57a50023b9046a8754ab339e37348e1877da9e08d025143864"
    }
  ],
  "ledgerHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
}
;
